"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.streamyard = exports.session = exports.ringcentral = void 0;

var tslib_1 = require("tslib");

var ringcentral = tslib_1.__importStar(require("./ringcentral"));

exports.ringcentral = ringcentral;

var session = tslib_1.__importStar(require("./session"));

exports.session = session;

var streamyard = tslib_1.__importStar(require("./streamyard"));

exports.streamyard = streamyard;
exports.default = ringcentral; // eslint-disable-line import/no-default-export